import React, { useEffect, useState } from 'react';
import { Button, theme } from 'antd';
import { _T } from '../src/Localization';
import { hasLocalStorage } from '../hooks/Storage';
import { updateAnalyticsConsent } from '../scripts/analytics';
const STORAGE_KEY = 'cookieConsent';
function getStoredConsent() {
    if (!hasLocalStorage())
        return null;
    try {
        return localStorage.getItem(STORAGE_KEY);
    }
    catch {
        return null;
    }
}
function storeConsent(value) {
    if (!hasLocalStorage())
        return;
    try {
        localStorage.setItem(STORAGE_KEY, value);
    }
    catch {
        // ignore
    }
}
export const CookieBanner = () => {
    const { token } = theme.useToken();
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const stored = getStoredConsent();
        if (stored === null) {
            setVisible(true);
        }
        else {
            updateAnalyticsConsent(stored === 'granted');
        }
    }, []);
    const handleAccept = () => {
        storeConsent('granted');
        updateAnalyticsConsent(true);
        setVisible(false);
    };
    const handleDecline = () => {
        storeConsent('denied');
        updateAnalyticsConsent(false);
        setVisible(false);
    };
    if (!visible)
        return null;
    return (React.createElement("div", { style: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            background: token.colorBgElevated,
            borderTop: `1px solid ${token.colorBorderSecondary}`,
            padding: `${token.paddingMD}px ${token.paddingLG}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: token.marginMD,
            flexWrap: 'wrap',
        } },
        React.createElement("span", { style: { color: token.colorText, fontSize: token.fontSize } }, _T('cookies.banner')),
        React.createElement("div", { style: { display: 'flex', gap: token.marginSM, flexShrink: 0 } },
            React.createElement(Button, { onClick: handleDecline }, _T('cookies.decline')),
            React.createElement(Button, { type: "primary", onClick: handleAccept }, _T('cookies.accept')))));
};
